import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsDownloadNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M5 10.01V8.557l2.54 2.474V3h1.058v8.029L11 8.68v1.463L8.069 13z" />
        <path
          clipRule="evenodd"
          d="M3.833 14.236A7.5 7.5 0 008 15.5 7.508 7.508 0 0015.5 8a7.5 7.5 0 10-11.667 6.236zm.556-11.64A6.5 6.5 0 018 1.5 6.508 6.508 0 0114.5 8 6.5 6.5 0 114.389 2.595z"
          fillRule="evenodd"
        />
      </g>
    </svg>
  )
);
SvgActionsDownloadNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgActionsDownloadNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsDownloadNormalXsmall;
